import axios from 'axios';
import auth from '@/utils/auth';

import {
  DELETE_NEWS,
  DELETE_NEWS_ERROR,
  DELETE_NEWS_SUCCESS,

  GET_NEWS,
  GET_NEWS_ERROR,
  GET_NEWS_SUCCESS,

  GET_ALL_NEWS,
  GET_ALL_NEWS_ERROR,
  GET_ALL_NEWS_SUCCESS,

  SAVE_NEWS,
  SAVE_NEWS_ERROR,
  SAVE_NEWS_SUCCESS,

  CREATE_NEWS,
  CREATE_NEWS_ERROR,
  CREATE_NEWS_SUCCESS,

  GET_CATEGORY,
  GET_CATEGORY_ERROR,
  GET_CATEGORY_SUCCESS,

  GET_CATEGORY_BYID,
  GET_CATEGORY_BYID_ERROR,
  GET_CATEGORY_BYID_SUCCESS,

  DELETE_CATEGORY,
  DELETE_CATEGORY_ERROR,
  DELETE_CATEGORY_SUCCESS,

  CREATE_CATEGORY,
  CREATE_CATEGORY_ERROR,
  CREATE_CATEGORY_SUCCESS,

  DELETE_MAIN_IMAGE,
  DELETE_MAIN_IMAGE_SUCCESS,
  DELETE_MAIN_IMAGE_ERROR,

  DELETE_SUB_IMAGE,
  DELETE_SUB_IMAGE_ERROR,
  DELETE_SUB_IMAGE_SUCCESS,

} from './constants';

export default {
  async [DELETE_NEWS]({ commit }, data) {
    try {
      commit(DELETE_NEWS);
      const response = await axios({
        url: `${process.env.API_URL}/api/news/delete`,
        method: 'DELETE',
        headers: auth.getAuthHeader(),
        data,
      });
      commit(DELETE_NEWS_SUCCESS, response.data);
    } catch (err) {
      commit(DELETE_NEWS_ERROR, err);
    }
  },
  async [DELETE_CATEGORY]({ commit }, data) {
    try {
      commit(DELETE_CATEGORY);
      await axios({
        url: `${process.env.API_URL}/api/news/categories/${data}`,
        method: 'DELETE',
        headers: auth.getAuthHeader(),
      });
      commit(DELETE_CATEGORY_SUCCESS);
    } catch (err) {
      commit(DELETE_CATEGORY_ERROR, err);
    }
  },

  async [DELETE_MAIN_IMAGE]({ commit }, data) {
    try {
      commit(DELETE_MAIN_IMAGE);
      await axios({
        url: `${process.env.API_URL}/api/newsmainimage/${data}`,
        method: 'DELETE',
        headers: auth.getAuthHeader(),
      });
      commit(DELETE_MAIN_IMAGE_SUCCESS);
    } catch (err) {
      commit(DELETE_MAIN_IMAGE_ERROR, err);
    }
  },
  async [DELETE_SUB_IMAGE]({ commit }, data) {
    try {
      commit(DELETE_SUB_IMAGE);
      await axios({
        url: `${process.env.API_URL}/api/newssubimages/${data}`,
        method: 'DELETE',
        headers: auth.getAuthHeader(),
      });
      commit(DELETE_SUB_IMAGE_SUCCESS);
    } catch (err) {
      commit(DELETE_SUB_IMAGE_ERROR, err);
    }
  },

  async [GET_NEWS]({ commit }, newsID) {
    try {
      commit(GET_NEWS);
      const response = await axios({
        url: `${process.env.API_URL}/api/news/${newsID}`,
        method: 'GET',
        headers: auth.getAuthHeader(),
      });
      commit(GET_NEWS_SUCCESS, response.data);
    } catch (err) {
      commit(GET_NEWS_ERROR, err);
    }
  },

  async [GET_ALL_NEWS]({ commit }, args) {
    try {
      commit(GET_ALL_NEWS);
      const response = await axios({
        url: `${process.env.API_URL}/api/syndicates/${args.syndicateID}/news`,
        method: 'GET',
        headers: auth.getAuthHeader(),
        params: {
          limit: args.limit || localStorage.pageLimit || '50',
          page: args.page || 0,
          sortField: args.sortField || 'date',
          sortDir: args.sortDir || 'DESC',
          filters: args.filters || null,
        },
      });
      commit(GET_ALL_NEWS_SUCCESS, response.data);
    } catch (err) {
      commit(GET_ALL_NEWS_ERROR, err);
    }
  },

  async [GET_CATEGORY]({ commit }, data) {
    try {
      commit(GET_CATEGORY);
      const response = await axios({
        url: `${process.env.API_URL}/api/news/categories`,
        method: 'GET',
        headers: auth.getAuthHeader(),
        data,
      });
      commit(GET_CATEGORY_SUCCESS, response.data);
    } catch (err) {
      commit(GET_CATEGORY_ERROR, err);
    }
  },
  async [GET_CATEGORY_BYID]({ commit }, categoryID) {
    try {
      commit(GET_CATEGORY_BYID);
      const response = await axios({
        url: `${process.env.API_URL}/api/news/categories/${categoryID}`,
        method: 'GET',
        headers: auth.getAuthHeader(),
      });
      commit(GET_CATEGORY_BYID_SUCCESS, response.data);
    } catch (err) {
      commit(GET_CATEGORY_BYID_ERROR, err);
    }
  },

  async [CREATE_CATEGORY]({ commit }, data) {
    try {
      commit(CREATE_CATEGORY);
      let url = `${process.env.API_URL}/api/news/categories`;
      let method = 'POST';
      if (data.categorieId) {
        url = `${url}/${data.categorieId}`;
        method = 'PUT';
      }
      const response = await axios({
        url,
        method,
        headers: auth.getAuthHeader(),
        data,
      });
      commit(CREATE_CATEGORY_SUCCESS, response.data);
      if (method === 'POST') {
        this.$router.push({ name: 'Coowner', params: { coownerID: response.data.coownerID } });
      }
    } catch (err) {
      commit(CREATE_CATEGORY_ERROR, err.response);
    }
  },

  async [SAVE_NEWS]({ commit }, data) {
    try {
      commit(SAVE_NEWS);
      const response = await axios({
        url: `${process.env.API_URL}/api/news/${data.newsID}`,
        method: 'PUT',
        headers: auth.getAuthHeader(),
        data,
      });
      commit(SAVE_NEWS_SUCCESS, response.data);
    } catch (err) {
      commit(SAVE_NEWS_ERROR, err);
    }
  },

  async [CREATE_NEWS]({ commit }, data) {
    try {
      commit(CREATE_NEWS);
      const response = await axios({
        url: `${process.env.API_URL}/api/news`,
        method: 'POST',
        headers: auth.getAuthHeader(),
        data,
      });
      commit(CREATE_NEWS_SUCCESS, response.data);
    } catch (err) {
      commit(CREATE_NEWS_ERROR, err);
    }
  },

};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Information/News/actions.js